import config from './config';

module.exports = {
    [`${config.BASE}`]: require('../sections/home'),

    [`${config.BASE}:lang`]: {
        section: require('../sections/home'),
        duplicate: true,
    },
};



/** WEBPACK FOOTER **
 ** ./pjax/routes.js
 **/